import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import * as contentful from 'contentful';
import Fade from 'react-reveal/Fade';
import {
  BrowserView,
  MobileView
} from "react-device-detect";

import videoMP4 from '../assets/bg-d.mp4';
import videoWEBm from '../assets/bg-d.webm';
import bg from '../assets/bg.gif';






class Single extends Component {

  state = {
    posts: [],
    postSlug : this.props.location.pathname,
    loading: true
  }

  client = contentful.createClient({
    space: 'fygct0me4xfd',
    accessToken: '72c82731a8873e4620dace6005f32eb0aa6ec31e576007fefe92e57fa2e73fc7'
  })

  componentDidMount() {
    document.body.classList.remove('hide');
    this.fetchPosts().then(this.setPosts);
    setTimeout(() => this.setState({ loading: false }), 500); 

    
  }

  fetchPosts = () => this.client.getEntries({
    'content_type': 'work',
    'fields.slug': this.state.postSlug,
  })


  setPosts = response => {
    this.setState({
      posts: response.items
    })
  }

  render() {

    document.body.classList.add('hide');
    

    const { loading } = this.state;

    if(loading) { 
      return null; 
    }


    return (

      <div>
 
      <div className="px-8 md:px-16 xl:px-64 py-12 md:py-32 z-40 relative text-white">
        <Fade>
          <div>
             {this.state.posts.map(({fields}, i) =>
            <h1 key={fields.title} className="text-5xl md:text-huge-md xl:text-huge mt-16">{fields.title}</h1>
            )}            
          </div>
        </Fade>

          <div className="md:flex mt-6 md:mt-12 md:-mx-4">
          <Fade  delay={300}>
            <div className="md:w-2/3 md:mx-4 border-t border-white pt-2">
                <p className="font-bold text-sm">Role</p>
                
                {this.state.posts.map(({fields}, i) =>
                  <h2 key={fields.role} className="font-semibold md:mt-6"> {fields.role}</h2>
                  )}  
            </div>
            </Fade>
            <Fade  delay={600}>
            <div className="md:w-1/3 mt-8 md:mt-0 md:mx-4 border-t border-white pt-2">
                <p className="font-bold text-sm">Client</p>
                {this.state.posts.map(({fields}, i) =>
                  <h2 key={fields.client} className="font-semibold md:mt-6"> {fields.client}</h2>
                  )}  
            </div>
            </Fade>
           

          </div>
          <Fade  delay={900}>
          <div>
          {this.state.posts.map(({fields}, i) =>
              <img key={fields.image.fields.file.url} className="mt-8 md:mt-24 mb-8 md:mb-12" src={fields.image.fields.file.url} alt={fields.title} />
          )}  
          </div>
          </Fade>
          <Fade>
          <div>
          {this.state.posts.map(({fields}, i) =>
          <a key={fields.link} href={fields.link} target="_blank" className="w-full md:w-auto text-center visitbtn inline-block py-4 px-12 border border-white text-white text-xl no-underline font-heading font-semibold"><span>Visit site</span></a>
          )} 
          <Link className="inline-block py-4 md:px-12 text-white text-xl no-underline font-heading font-light hover:underline" to='/work'>Back to works</Link>
          </div>
          </Fade>
      </div>

      <BrowserView>
        <div className="video-container">
          <video autoPlay loop muted>
            <source src={videoMP4} type="video/mp4" />
            <source src={videoWEBm} type="video/webm" />
          </video>
        </div>
      </BrowserView>
      <MobileView>
        <div className="video-container bg-cover bg-center" style={{backgroundImage: "url(" + bg + ")"}}>
        </div>
      </MobileView>

      </div>
    );
  }
}

export default Single;





// WEBPACK FOOTER //
// ./src/pages/Single.js